import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TabState {
    value: boolean
}

const initialState = { value: true } as TabState

const showTabs = createSlice({
  name: 'showTabs',
  initialState,
  reducers: {
    setShowTabs(state,action:PayloadAction<boolean>){
        state.value = action.payload
    },
  },
 
});

// Reducer
export default showTabs.reducer;

// Actions
export const {setShowTabs} = showTabs.actions;